import { useEffect } from 'react';

/** Starts every navigation at the top of the new page. */
export const useScrollToTop = (key: string): void => {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [key]);
};
